import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 12, 18, 0.94);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 1.25rem 1.25rem;
  box-sizing: border-box;
`;

const FullImage = styled.img`
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  user-select: none;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  font-size: 1.85rem;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 2px;

  &:hover {
    background: rgba(255, 255, 255, 0.26);
  }

  &:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
  }
`;

const CameraPhotoViewer = ({ src, alt, onClose }) => {
  const closeRef = useRef(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!src) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();

    const onKey = (event) => {
      if (event.key === "Escape") onCloseRef.current();
    };
    document.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [src]);

  if (!src) return null;

  return createPortal(
    <Backdrop
      role="dialog"
      aria-modal="true"
      aria-label={alt || "Foto em tela cheia"}
      onClick={() => onCloseRef.current()}
    >
      <CloseButton
        ref={closeRef}
        type="button"
        aria-label="Fechar"
        onClick={(event) => {
          event.stopPropagation();
          onCloseRef.current();
        }}
      >
        ×
      </CloseButton>
      <FullImage
        src={src}
        alt={alt || "Foto"}
        onClick={(event) => event.stopPropagation()}
      />
    </Backdrop>,
    document.body
  );
};

export default CameraPhotoViewer;
